import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";
import { i18nConfig } from "./i18n";
import Header from "./components/header/header";
import MopButtons from "./components/buttons/buttons";
import MainView from "./components/mainView/mainView";
import { CURRENCIES, MOP_TYPES, SURFACE_UNITS } from "./contants";
import CurrencySelector from "./components/currencySelector/currencySelector";
import SurfaceUnitSelector from "./components/surfaceUnitSelector/surfaceUnitSelector";
import { CustomThemeContext } from "./themes/customThemeProvider";
import { getUrlParams } from "./utils/utils";
import "./App.css";

function App() {
  const { i18n } = useTranslation(["common"]);
  const [mopType, setMopType] = useState(MOP_TYPES.IMOPXL);
  const [currency, setCurrency] = useState(CURRENCIES.USD);
  const [surfaceUnit, setSurfaceUnit] = useState(SURFACE_UNITS.m2);

  // eslint-disable-next-line
  const { currentTheme, setTheme } = useContext(CustomThemeContext);

  useEffect(() => {
    const { theme, language } = getUrlParams();
    setTheme(theme);
    if (i18nConfig.langs.includes(language)) {
      i18n.changeLanguage(language);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="App">
      <CurrencySelector currency={currency} setter={setCurrency} />
      <SurfaceUnitSelector surfaceUnit={surfaceUnit} setter={setSurfaceUnit} />
      <Header />
      <MopButtons mopType={mopType} setter={setMopType} />
      <MainView
        mopType={mopType}
        currency={currency}
        surfaceUnit={surfaceUnit}
      />
    </div>
  );
}

export default App;
